/* eslint-disable camelcase */
/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import StarBase from '../StarBase';
import Phaser from 'phaser';

export default class LevelSelect_Star extends StarBase {
  constructor (scene, x, y, countBy, pointerUpFunction) {
    super(scene, 0, 0);
    this.pointerUpFunction = pointerUpFunction;
    this.starButton.countBy = countBy;
    this.starButton.scaleX = .6;
    this.starButton.scaleY = .6;

    this.sprite = scene.add.container(x, y);
    this.y = y;
    this.sprite.add(this.starButton);

    const text = scene.add.bitmapText(0, 0, 'Nasalization','', 45);
    text.setOrigin(.5);
    text.align = 'center';
    text.tint = '0x360b5d';
    text.text = `${this.starButton.countBy}${ABCyaPhaser.Localization.instance.getLocalizedString('number_plural')}`;
    text.setDepth(1);
    text.setPosition(this.starButton.x, this.starButton.y + 5);
    this.sprite.add(text);

    this.text = text;
  }

  OnDown() {
    super.OnDown();
    this.text.x -= 3;
    this.text.y += 8;
  }

  OnUp() {
    super.OnUp();
    this.pointerUpFunction(this);
    this.text.x = this.starButton.x;
    this.text.y = this.starButton.y + 10;
  }

  CountBy() {
    return this.countBy;
  }
}
